import { render, staticRenderFns } from "./competitionInfo.vue?vue&type=template&id=e8a1f454&scoped=true&"
import script from "./competitionInfo.vue?vue&type=script&lang=js&"
export * from "./competitionInfo.vue?vue&type=script&lang=js&"
import style0 from "./competitionInfo.vue?vue&type=style&index=0&id=e8a1f454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a1f454",
  null
  
)

export default component.exports